<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div class="bg-white rounded-xl shadow-lg p-6 w-full max-w-sm">
      <h3 class="text-lg font-semibold mb-2">{{ title }}</h3>
      <p class="mb-4 text-gray-700">{{ message }}</p>
      <div class="flex justify-end space-x-2">
        <button v-if="cancelText" @click="$emit('cancel')" class="px-4 py-2 rounded bg-gray-200">{{ cancelText }}</button>
        <button @click="$emit('confirm')" class="px-4 py-2 rounded bg-orange-600 text-white">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  visible: Boolean,
  title: {
    type: String,
    default: 'Confirm Action'
  },
  message: {
    type: String,
    default: 'Are you sure you want to proceed?'
  },
  confirmText: {
    type: String,
    default: 'Confirm'
  },
  cancelText: {
    type: String,
    default: 'Cancel'
  }
})

defineEmits(['confirm', 'cancel'])
</script> 